// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VYLK","option":"styles_option__2qks5","active":"styles_active__mQWer"};